"use client";

import { useState } from "react";
import ProductsFiltersCard from "@/components/products/ProductsFiltersCard";
import ProductsListCard from "@/components/products/ProductsListCard";
import { Pagination } from "@/components/common";
import Search from "@/components/ui/Search";
import { FilterOptions, ProductsList } from "@/@types";

type Props = {
  productsList: ProductsList;
  productsFilters: FilterOptions;
  industrySlug?: string;
  familySlug?: string;
  subfamilySlug?: string;
  brandSlug?: string;
  isPorMarca?: boolean;
};

export default function ProductsContainerCard({
  productsList,
  productsFilters,
  industrySlug = "",
  familySlug = "",
  subfamilySlug = "",
  brandSlug = "",
  isPorMarca = false,
}: Props) {

  const [unitType, setUnitType] = useState<"metric" | "english">("metric");
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);

  const toggleFilterModal = () => {
    setIsFilterModalOpen((prev) => !prev);
  };

  return (
    <div className="grid lg:grid-cols-[25%_75%] mt-8">
      <div className="grid grid-cols-1 auto-rows-min">
        <Search onOpenFilters={toggleFilterModal} />
        <ProductsFiltersCard
          filters={productsFilters}
          unitType={unitType}
          setUnitType={setUnitType}
          selectedIndustry={industrySlug}
          selectedFamily={familySlug}
          selectedSubfamily={subfamilySlug}
          selectedBrand={brandSlug}
          isMenuOpen={isFilterModalOpen}
          toggleMenu={toggleFilterModal}
        />
      </div>
      <div className="lg:pl-4 pt-4 lg:pt-0">
        <>
          <ProductsListCard
            products={productsList}
            unitType={unitType}
            industrySlug={!isPorMarca ? industrySlug : ""}
          />
          <Pagination
            result="Productos"
            currentPage={productsList.meta.current_page}
            lastPage={productsList.meta.last_page}
            totalResults={productsList.meta.total}
            perPage={productsList.meta.per_page}
          />
        </>
      </div>
    </div>
  );
}
